import React, { useRef, useEffect, useState } from 'react'
import { useCompoundBody } from '@react-three/cannon'
import { useFrame } from '@react-three/fiber';
import ShotBtn from './ShotBtn';
import HockeyStick from './HockeyStick';

export const Arm = (props) => {
    const { position = [.58, 1.75, .8], rotation = [0, -1, 0] } = props;
    const speed = 1;
    const armRotation = useRef([0, 0, 0])
    const armLength = 0.6;
    const handHeight = 0.177;
    const handWidth = 0.09;

    const [isArmMoving, setIsArmMoving] = useState(false);

    const hand = {
        type: 'Box',
        position: [-armLength + .01, -handHeight / 4 + .02, -.01],
        rotation: [0.2, 0, -.6],
        args: [handWidth - .02, handHeight + .1, 0.01]
    }
    const arm = {
        position: [-armLength / 2, 0.08, 0],
        type: 'Box',
        args: [armLength, 0.05, 0.02]
    }
    const shapes = [hand, arm]

    const [ref, api] = useCompoundBody(() => ({
        mass: 0,
        position,
        rotation,
        type: 'Kinematic',
        shapes: shapes,
    }), null, [position, rotation, arm, hand, shapes]);

    useEffect(() => {
        // subscribe for rotation update so we can basic costrains to arm's movement
        const unsubscribe = api.rotation.subscribe((r) => (armRotation.current = r))
        return unsubscribe
    }, [api.rotation])

    useEffect(() => {
        api.angularVelocity.set(0, isArmMoving ? speed : 0, 0);
    }, [isArmMoving, api.angularVelocity])


    useFrame(() => {
        if (!isArmMoving) return;

        if (armRotation.current[1] > 0) {
            // retract arm
            api.angularVelocity.set(0, -speed, 0)
        }
        if (armRotation.current[1] < -1) {
            // retracted
            setIsArmMoving(false)
        }
    })

    return (
        <>
            <group ref={ref} {...props}>
                <HockeyStick position={[0, -.14, 0]} rotation={[0, 0, 0]} />

                {/*
                Uncomment when debugging physics
                <mesh position={hand.position} rotation={hand.rotation}>
                    <boxBufferGeometry args={hand.args} />
                    <meshPhongMaterial color={0x040404} />
                </mesh>
                <mesh position={arm.position}>
                    <boxBufferGeometry args={arm.args} />
                    <meshPhongMaterial color={0x040404} />
                </mesh> */}
            </group>
            <ShotBtn active={!isArmMoving} onClick={() => setIsArmMoving(true)} />
        </>
    )
}
export default Arm;